/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {ConfigurableFocusTrapConfig as ɵangular_material_src_cdk_a11y_a11y_b} from './focus-trap/configurable-focus-trap-config';
export {FocusTrapManager as ɵangular_material_src_cdk_a11y_a11y_a} from './focus-trap/focus-trap-manager';